import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.withCredentials = true;

export const get_Graphical_Statistics = async (values) => {
    const res = await axios.post(`${API_URL}order-report/graphical-statistics`, values);

    return res;
};
export const get_Data_Statistics = async (values) => {
    const res = await axios.post(`${API_URL}order-report/data-statistics`, values);
    return res;
};
